import { Navigate } from 'react-router-dom'
import { useTodayAttendance } from '@/hooks/learner/useTodayAttendance'
import { resolveAttendanceRestrictedHome } from '@/hooks/learner/useAttendanceAccess'
import { PREVIEW_HOME } from '@/hooks/learner/usePreviewGate'

/**
 * /my 랜딩 분기. 대기 원생과 무료체험 중 미등원/하원 원생은 마이페이지로,
 * 일반 과정의 미등원/하원 원생은 도서관으로, 그 외(에러 포함 fail-open)는 오늘 수업으로.
 * 미배정+미등록 학습자가 /my/today 404에 갇히던 trap을 해소한다 (축3·엣지2).
 */
export default function MyIndexRedirect() {
  const { data, isLoading } = useTodayAttendance()
  if (isLoading) return null
  if (data?.enrollmentStatus === 'WAITING') return <Navigate to={PREVIEW_HOME} replace />
  if (data?.enrollmentStatus === 'ENROLLED' && data.attendanceStatus !== 'IN') {
    return <Navigate to={resolveAttendanceRestrictedHome(data)} replace />
  }
  return <Navigate to="/my/today" replace />
}
